import React from 'react';
import PropTypes from 'prop-types';

import {
    LayoutComponent_Grid_Col as Col,
    LayoutComponent_Grid_Row as Row,
    LayoutComponent_Checkout_Title as CheckoutScreenTitle,
    LayoutComponent_Container as CheckoutScreenContainer,
    LayoutComponent_Checkout_ContentWrap as CheckoutScreenContentWrap,
} from 'ggApp/modules/layout';
import { OrderComponentSummary } from 'ggApp/modules/order';
import { CheckoutBackToCartLink } from 'ggApp/modules/checkout/components';
import If from 'ggApp/shared/components/Conditional';
import useMount from 'ggApp/shared/hooks/useMount';

import { dispatchDiscountBannerEvent } from 'ggApp/modules/featureFlag/utils/tracking';
import { FeedbackBanner } from './styled';

const ScreenWrap = ({
    children,
    order,
    feedbackBannerAvailable,
    feedbackBannerText,
    feedbackBannerCopyableText,
    getCFDiscountBanner,
    discountBannerFeatureFlagData,
}) => {
    useMount(() => {
        getCFDiscountBanner();
        if (order.store_code === 'de') {
            const flagValue =
                discountBannerFeatureFlagData && discountBannerFeatureFlagData.variantKey;
            dispatchDiscountBannerEvent(flagValue, 'checkout');
        }
    });

    return (
        <section>
            <CheckoutScreenTitle tk="CHECKOUT_PAYMENT_TITLE" />
            <CheckoutScreenContainer>
                <If condition={feedbackBannerAvailable && feedbackBannerText}>
                    <FeedbackBanner
                        text={feedbackBannerText}
                        copyableText={feedbackBannerCopyableText}
                    />
                </If>
                <CheckoutScreenContentWrap>
                    <Row cols={[1, 1]}>
                        <Col desktop={40}>
                            <OrderComponentSummary order={order} hideMobile desktopColumnItem />
                            <CheckoutBackToCartLink />
                        </Col>
                        <Col desktop={60}>{children}</Col>
                    </Row>
                </CheckoutScreenContentWrap>
            </CheckoutScreenContainer>
        </section>
    );
};

ScreenWrap.propTypes = {
    children: PropTypes.node.isRequired,
    order: PropTypes.shape({}).isRequired,
    feedbackBannerFeatureFlag: PropTypes.shape({
        variant: PropTypes.string,
    }).isRequired,
    getCFDiscountBanner: PropTypes.func,
    feedbackBannerText: PropTypes.string,
    feedbackBannerAvailable: PropTypes.bool,
    discountBannerFeatureFlagData: PropTypes.shape({
        variantKey: PropTypes.string,
    }),
};

ScreenWrap.defaultProps = {
    getCFDiscountBanner: () => {},
    feedbackBannerText: '',
    feedbackBannerAvailable: false,
    discountBannerFeatureFlagData: {},
};

export default ScreenWrap;
